import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { QueryKeys } from '~/services/loyalty/constants';
import type { LoyaltyApiError, MemberRewardsResponse } from '~/lib/data-contract/loyalty';
import type { AllowedOptions } from '../allowedQueryOptions';
import { useLoyaltyContext } from '..';

export const useMemberRewards = <TData = MemberRewardsResponse>(
    options?: AllowedOptions<MemberRewardsResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<MemberRewardsResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.MEMBER_REWARDS],
        queryFn: createLoyaltyQuery('GetMemberRewards', translate, trackError, {
            memberId: businessCentralId,
        }),
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
